
module.exports = function getResource(label, vars = []) {
    const resources = { all: 'All ' };
    return resources[label];
};
